import { __awaiter, __generator } from "tslib";
// src/hooks/useClipboard.ts
import { useState } from "react";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../../apps/corptrip/src/store/slices";
export var useClipboard = function () {
    var dispatch = useDispatch();
    var _a = useState(false), copied = _a[0], setCopied = _a[1];
    var copyToClipboard = function (text, successMessage) { return __awaiter(void 0, void 0, void 0, function () {
        var err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, navigator.clipboard.writeText(text)];
                case 1:
                    _a.sent();
                    setCopied(true);
                    dispatch(setSnackbar({
                        message: successMessage || "Copied to clipboard",
                        severity: "success",
                        open: true,
                    }));
                    // Reset copied state after a short delay
                    setTimeout(function () { return setCopied(false); }, 2000);
                    return [3 /*break*/, 3];
                case 2:
                    err_1 = _a.sent();
                    console.error("Failed to copy: ", err_1);
                    dispatch(setSnackbar({
                        message: "Failed to copy to clipboard",
                        severity: "error",
                        open: true,
                    }));
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return { copied: copied, copyToClipboard: copyToClipboard };
};
